import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "i-1971553688__a",
      width: "20",
      height: "20",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#fff",
        "fill-rule": "evenodd",
        d: "M2.903 20A2.903 2.903 0 0 1 0 17.097V2.903a2.903 2.903 0 1 1 5.806 0v14.194C5.806 18.7 4.506 20 2.903 20M10 17.097a2.903 2.903 0 0 1-2.903-2.903V5.806a2.903 2.903 0 1 1 5.806 0v8.388c0 1.603-1.3 2.903-2.903 2.903m4.194 0a2.903 2.903 0 1 0 5.806 0V2.903a2.903 2.903 0 1 0-5.806 0z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#i-1971553688__a)" }, [
      _createElementVNode("rect", {
        width: "33.677",
        height: "21.032",
        x: "-6.838",
        y: "-.516",
        fill: "currentColor",
        rx: ".645"
      })
    ], -1)
  ])))
}
export default { render: render }